export const environment = {
  production: true,

  redirectUri: 'https://export.tvilight.io/exports',

  loginUrl: 'https://passport.tvilight.io/oauth/authorize',
  logoutUrl: 'https://passport.tvilight.io/users/sign_out',
  userinfoEndpoint: 'https://passport.tvilight.io/api/me',
  clientId: '8ea346fe669a2d86f5d25b899d0f5279b1f905e66b5d16ab354ad3f31baf25c3',

  ctlUrl: 'https://ctl.tvilight.io/api',
  exportUrl: 'https://ctl.tvilight.io/exports/commissioning'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts